// @flow
import type AExperimentsClient from 'app/common/lib/ExperimentsClient/AExperimentsClient';

export default ((__SERVER__ ? require('./node').default : require('./browser').default): Class<
  AExperimentsClient,
>);
